import React, { useState } from "react";
// import userImage from "../../assets/user.png"; // Placeholder
// import liveIcon from "../../assets/images/icons/live.png"; // Optional live badge
import userImage from "../../assets/profile.png";
import pipaanlogo from "../../assets/pipaanlogo.png";
import camerastory from "../../assets/camerastory.png";
import videostory from "../../assets/videostory.png";

import { IoMdClose } from "react-icons/io";
import Modal from "react-modal";
import { FaMicrophone, FaSmile, FaPaperPlane } from "react-icons/fa";
import { MdPhoto } from "react-icons/md";
import axios from "axios";


// Dummy story list for left preview
const storyList = [
  { id: 1, name: "Praveen", avatar: userImage, media: userImage, time: "2h ago" },
  { id: 2, name: "Praveen", avatar: userImage, media: userImage, time: "3h ago" },
  { id: 3, name: "Praveen", avatar: userImage, media: userImage, time: "5h ago" },
];
Modal.setAppElement("#root"); // Important for accessibility

const StoryBar = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [isChoiceModalOpen, setIsChoiceModalOpen] = useState(false);
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [previewURL, setPreviewURL] = useState(null);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedStory, setSelectedStory] = useState(null);
  const [uploadedMedia, setUploadedMedia] = useState([]);
  const [error, setError] = useState(null);
const [userStory, setUserStory] = useState(null); // or an array if multiple

const storyUsers = [
  {
    id: 0,
    name: "Add Story",
    avatar: userImage,
    isAdd: true,
    hasStory: !!userStory,
    story: userStory
  },
  { id: 1, name: "Praveen", avatar: userImage, isLive: true },
  { id: 2, name: "Praveen", avatar: userImage },
  { id: 3, name: "Praveen", avatar: userImage },
  { id: 4, name: "Praveen", avatar: userImage },
];
const [isStoryViewerOpen, setIsStoryViewerOpen] = useState(false);
const [activeStory, setActiveStory] = useState(null);
  const handlePostStory = async () => {
    try {
      const uploaded = await uploadFiles();
      setUserStory(uploaded); // save the uploaded story media
      setUploadedMedia([]);
      setIsCreateModalOpen(false);
    } catch (error) {
      console.error("Error posting story:", error);
    }
  };
  
  

  const handleStoryClick = (user) => {
    if (user.isAdd) {
      if (user.hasStory && user.story?.length > 0) {
        // If user already added a story, show it
        setSelectedStory(user.story); // user's own uploaded story
        setIsViewModalOpen(true);
      } else {
        // No story yet, open choice modal to add
        setIsChoiceModalOpen(true);
      }
    } else {
      // For others, load from the main story list
      setSelectedStory(storyList[0]); // You might want to update this logic
      setIsViewModalOpen(true);
    }
  };
  
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const mediaFiles = files.map((file) => ({
      file,
      url: URL.createObjectURL(file), // For preview
    }));
    
    setUploadedMedia((prev) => [...prev, ...mediaFiles]); // assuming uploadedMedia is a state
    setPreviewURL(mediaFiles[0].url); // <-- Add this line to set preview

    setIsChoiceModalOpen(false);
    setIsCreateModalOpen(true);
  };
  const uploadFiles = async () => {
    if (uploadedMedia.length === 0) return alert("Please select files");
  
    const fileData = uploadedMedia.map((media) => ({
      fileName: media.file.name,
      fileType: media.file.type
    }));
  
    try {
      // Step 1: Generate pre-signed URLs
      const response = await axios.post(
        'https://pipaan.com360degree.com/api/aws/generate-presigned-url',
        { files: fileData },
        {
          headers: {
            'token': sessionStorage.getItem("accessToken")
          }
        }
      );
  
      if (!response.data.success) {
        throw new Error('Failed to generate pre-signed URLs');
      }
  
      const preSignedUrls = response.data.directory;
  
      // Step 2: Upload files to S3
      await Promise.all(
        preSignedUrls.map(async (item, index) => {
          await axios.put(item.presignedUrl, uploadedMedia[index].file, {
            headers: {
              'Content-Type': uploadedMedia[index].file.type,
              'Content-Encoding': 'binary'
            }
          });
          console.log(`${item.fileName} uploaded successfully`);
        })
      );
  
      // Step 3: Return uploaded file info for story usage
      const uploaded = preSignedUrls.map(item => ({
        media_type: item.fileType.startsWith("image") ? "image" : "video",
        url: item.fileUrl
      }));
  
      return uploaded;
  
    } catch (error) {
      console.error('Upload error:', error);
      setError('Failed to upload files. Please try again.');
      throw new Error('Failed to upload files');
    }
  };
    

  return (
    <>
      {/* 🔹 PLACE THIS MODAL AT THE TOP LEVEL OF YOUR JSX RETURN */}
      {isStoryViewerOpen && activeStory && (
        <div className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center">
          <div className="bg-white p-4 rounded-lg max-w-xl w-full">
            <button onClick={() => setIsStoryViewerOpen(false)}>Close</button>
            <div className="flex overflow-x-auto gap-4">
              {activeStory.map((media, index) =>
                media.media_type === "image" ? (
                  <img key={index} src={media.url} className="h-[400px]" />
                ) : (
                  <video key={index} controls src={media.url} className="h-[400px]" />
                )
              )}
            </div>
          </div>
        </div>
      )}
      <div className="w-full overflow-x-auto px-1 py-3">
        <div className="flex gap-3 min-w-max">
          {/* {storyUsers.map((user, index) => (
            <div className="relative">
              {user.isLive && (
                <div className="absolute top-[-5px] left-0 right-0 bg-[#BE1F2E] text-white  px-2 py-0 rounded-full z-[99] text-[8px] w-[fit-content] m-auto"  style={{lineHeight: user.isAdd ? "12px" : "12px"
                 }}>
                  LIVE
                </div>
              )}
            <div
              key={index}
              className={` relative flex-shrink-0  rounded-[20px] overflow-hidden shadow-md z-[1] ${
                user.isAdd ? "bg-[#f3f3f3]" : "cursor-pointer",
                 user.isLive ? "border-2 border-[#FF0018]" : ""
              }`}   
              
              
              onClick={() => handleStoryClick(user)}
              style={{margin: user.isAdd ? "auto 0px" : "",
               height: user.isAdd ? "109px" : "155px",width: user.isAdd ? "80px" : " 80px",  border: user.isAdd ? "1.5px solid" : "",

               borderImageSource: user.isAdd ? "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)" : "",
              }}
            >
              
              <img
                src={user.avatar}
                alt={user.name}
                className="w-full h-full object-cover z-[0] relative"
                style={{
                  filter: user.isAdd ? "blur(3px) brightness(0.9)" : "none", 
                }}
              />
              {user.isLive && (
                <div class="absolute inset-0 bg-red-500 opacity-30"></div>
              )}
              <div className="absolute bottom-4 right-0 left-0 bg-[#fff] text-[#000] text-xs font-medium text-center py-1 px-1 rounded-full flex  " style={{
                  filter: user.isAdd ? "none" : "none", display:user.isAdd ? "block" : "flex", bottom: user.isAdd ? "0px" : "", borderRadius: user.isAdd ? "0px" : "", margin: user.isAdd ? "auto" : "auto", width: user.id ? "fit-content" : "auto", 
                }}>
                  <div className="relative flex align-center justify-center"  style={{
                  height: user.isAdd ? "35px" : "",
                }}>
              <img
                src={user.avatar}
                alt={user.name}
                className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                style={{
                  filter: user.isAdd ? "none" : "none",
                  margin: user.isAdd ? "auto" : "",
                  top: user.isAdd ? "-25px" : "",
                  position: user.isAdd ? "absolute" : "",
                  width: user.isAdd ? "35px" : "",height: user.isAdd ? "35px" : "",
                  right: user.isAdd ? "0": "",
                  left: user.isAdd ? "0" : ""
                }}
              />
              <p class="" style={{
                  padding: user.isAdd ? "15px 0px 10px" : "0",fontSize: user.isAdd ? "8px" : "6px",fontWeight: user.isAdd ? "600" : "500",lineHeight: user.isAdd ? "12px" : "12px"
                
                }}>{user.name}</p>
                </div>
              </div>
            </div>
            </div>
          ))} */}
          {storyUsers.map((user, index) => (
            <div key={index} className="relative my-auto ">
              {user.isLive && (
                <div className="absolute top-[-5px] left-0 right-0 bg-[#BE1F2E] text-white px-2 py-0 rounded-full z-[99] text-[8px] w-fit mx-auto leading-[12px]">
                  LIVE
                </div>
              )}

              {user.isAdd ? (
                // Special wrapper for 'Add Story' with gradient border
                <div
                  className="p-[2px] rounded-[20px]"
                  style={{
                    background: "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)",
                    width: "84px",
                    height: "113px",
                    margin: "auto 0",
                  }}
                >
                  <div
                    className="relative flex-shrink-0 rounded-[20px] overflow-hidden shadow-md bg-[#f3f3f3]"
                    style={{ height: "100%", width: "100%" }}
                    onClick={() => handleStoryClick(user)}
                  >
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="w-full h-full object-cover z-0 blur-[3px] brightness-90"
                    />
                    <div className="absolute bottom-4 right-0 left-0 bg-[#fff] text-[#000] text-xs font-medium text-center py-1 px-1 rounded-full flex  " style={{
                      filter: user.isAdd ? "none" : "none", display: user.isAdd ? "block" : "flex", bottom: user.isAdd ? "0px" : "", borderRadius: user.isAdd ? "0px" : "", margin: user.isAdd ? "auto" : "auto", width: user.id ? "fit-content" : "auto",
                    }}>
                      <div className="relative flex align-center justify-center" style={{
                        height: user.isAdd ? "35px" : "",
                      }}>
                        <img
                          src={user.avatar}
                          alt={user.name}
                          className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                          style={{
                            filter: user.isAdd ? "none" : "none",
                            margin: user.isAdd ? "auto" : "",
                            top: user.isAdd ? "-25px" : "",
                            position: user.isAdd ? "absolute" : "",
                            width: user.isAdd ? "35px" : "", height: user.isAdd ? "35px" : "",
                            right: user.isAdd ? "0" : "",
                            left: user.isAdd ? "0" : ""
                          }}
                        />
                        <p class="" style={{
                          padding: user.isAdd ? "15px 0px 10px" : "0", fontSize: user.isAdd ? "8px" : "6px", fontWeight: user.isAdd ? "600" : "500", lineHeight: user.isAdd ? "12px" : "12px"

                        }}>{user.name}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                // Normal Story Users
                <div
                  className={`gradiend-story relative flex-shrink-0 rounded-[20px] overflow-hidden cursor-pointer`}
                  style={{ height: "155px", width: "80px", background: user.isLive ? "" : "linear-gradient(266.95deg, #1DE78B 2.65%, #08AEEA 97.47%)", border: user.isLive ? "2px solid #BE1F2E" : "", }}
                  onClick={() => handleStoryClick(user)}
                >
                  <img
                    src={user.avatar}
                    alt={user.name}
                    className="w-full h-full object-cover z-0"
                  />
                  {user.isLive && (
                    <div className="absolute inset-0 bg-[#FF000033] opacity-30 "></div>
                  )}
                  <div className="absolute bottom-4 right-0 left-0 bg-white text-black text-xs font-medium text-center py-1 px-1 rounded-full flex items-center justify-center mx-auto w-fit">
                    <img
                      src={user.avatar}
                      alt={user.name}
                      className="w-[10px] h-[10px] object-cover mr-1 rounded-full"
                    />
                    <p className="text-[6px] font-medium leading-[12px]">{user.name}</p>
                  </div>
                </div>
              )}
            </div>
          ))}

        </div>
      </div>

      {/* Story Modal */}
      <Modal
        isOpen={isChoiceModalOpen}
        onRequestClose={() => setIsChoiceModalOpen(false)}
        contentLabel="Create Story"
        className="relative bg-white rounded-2xl p-8 max-w-md w-full mx-auto mt-24 outline-none z-[999]"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
      >
        <div className="flex justify-between items-center mb-6">
          <img src={pipaanlogo} alt="Pipaan" className="h-8" />
          <button onClick={() => setIsChoiceModalOpen(false)}>
            <IoMdClose size={24} className="text-green-700" />
          </button>
        </div>
        <div className="flex justify-center gap-6">
          {/* Photo Story */}
          <label className="cursor-pointer flex flex-col items-center">
            <div className="w-[90px] h-[90px] bg-gradient-to-br from-green-100 to-white border border-green-400 rounded-[20px] flex items-center justify-center">
              <img src={camerastory} alt="Photo" className="w-6 h-6" />
            </div>
            <p className="mt-2 text-sm font-medium text-gray-700 text-center">
              Create a Photo Stories
            </p>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleFileSelect}
            />
          </label>

          {/* Video Story */}
          <label className="cursor-pointer flex flex-col items-center">
            <div className="w-[90px] h-[90px] bg-gradient-to-br from-green-100 to-white border border-green-400 rounded-[20px] flex items-center justify-center">
              <img src={videostory} alt="Video" className="w-6 h-6" />
            </div>
            <p className="mt-2 text-sm font-medium text-gray-700 text-center">
              Create a Video Stories
            </p>
            <input
              type="file"
              accept="video/*"
              className="hidden"
              onChange={handleFileSelect}
            />
          </label>
        </div>
      </Modal>
      {/* STEP 2: Preview & Tag */}
      <Modal
        isOpen={isCreateModalOpen}
        onRequestClose={() => setIsCreateModalOpen(false)}
        className="relative bg-white rounded-2xl p-6 max-w-3xl w-full mx-auto mt-16 outline-none z-[999]"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
      >
        <div className="flex justify-between items-center mb-4">
          <img src={pipaanlogo} alt="Pipaan" className="h-8" />
          <button onClick={() => setIsCreateModalOpen(false)}>
            <IoMdClose size={24} className="text-green-700" />
          </button>
        </div>

        <div className="flex flex-col md:flex-row gap-6 items-center">
          {/* Main Preview */}
          <div className="flex-1">
          <div className="flex gap-4 overflow-x-auto w-full">
  {uploadedMedia.map((media, index) => (
    media.file.type.startsWith("image") ? (
      <img
        key={index}
        src={media.url}
        alt={`preview-${index}`}
        className="h-[200px] rounded-xl object-cover"
      />
    ) : (
      <video
        key={index}
        src={media.url}
        controls
        className="h-[200px] rounded-xl"
      />
    )
  ))}
</div>

          </div>

          {/* Right Side: Options */}
          <div className="flex flex-col items-center justify-center gap-4 w-full md:w-[200px]">
            <div className="flex gap-4">
              <button className="flex flex-col items-center bg-green-100 px-3 py-2 rounded-full">
                <span className="text-xl">✍️</span>
                <span className="text-xs mt-1">Text</span>
              </button>
              <button className="flex flex-col items-center bg-green-100 px-3 py-2 rounded-full">
                <span className="text-xl">🏷️</span>
                <span className="text-xs mt-1">Tag</span>
              </button>
            </div>

            {/* Mini Previews */}
            <div className="flex gap-2 overflow-x-auto">
              {uploadedMedia.map((file, index) => (
                <img
                  key={index}
                  src={file}
                  alt={`thumb-${index}`}
                  className="w-14 h-14 object-cover rounded-lg"
                  onClick={() => setPreviewURL(file)}
                />
              ))}
            </div>

            <button 
            onClick={handlePostStory}
            className="mt-4 w-full bg-black text-white py-2 rounded-lg text-sm font-semibold">
              Share Story
            </button>
          </div>
        </div>
      </Modal>

      {/* STEP 3: View Story Modal */}
      <Modal
        isOpen={isViewModalOpen}
        onRequestClose={() => setIsViewModalOpen(false)}
        className="relative bg-white rounded-2xl p-4 max-w-5xl w-full mx-auto mt-12 outline-none z-[999]"
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center"
      >
        <div className="flex items-start">
          {/* Left Story List */}
          <div className="w-[100px] space-y-3">
            {storyList.map((story) => (
              <div
                key={story.id}
                onClick={() => setSelectedStory(story)}
                className="w-[70px] h-[120px] overflow-hidden rounded-xl border-2 border-blue-300 cursor-pointer"
              >
                <img src={story.media} alt="story" className="w-full h-full object-cover" />
              </div>
            ))}
          </div>

          {/* Main Story Content */}
          <div className="flex-1 px-6">
            <div className="flex justify-between items-center mb-4">
              <img src={pipaanlogo} alt="Pipaan" className="h-8" />
              <button onClick={() => setIsViewModalOpen(false)}>
                <IoMdClose size={24} className="text-green-700" />
              </button>
            </div>

            <div className="relative w-full">
              <img
                src={selectedStory?.media}
                alt="Full Story"
                className="rounded-xl w-full max-h-[500px] object-cover"
              />
              <div className="absolute top-3 left-3 bg-black bg-opacity-60 text-white px-3 py-1 rounded-full text-sm">
                <p className="font-medium">{selectedStory?.name}</p>
                <p className="text-xs">{selectedStory?.time}</p>
              </div>
            </div>

            {/* Comment Box */}
            <div className="mt-4 flex items-center border rounded-full px-4 py-2 shadow-md">
              <img src={userImage} className="w-8 h-8 rounded-full mr-2" alt="me" />
              <input
                placeholder="Add a comment"
                className="flex-1 text-sm text-gray-800 focus:outline-none"
              />
              <button className="text-gray-500 hover:text-black px-2">
                <FaSmile />
              </button>
              <label className="cursor-pointer text-gray-500 hover:text-black px-2">
                <MdPhoto />
                <input type="file" className="hidden" />
              </label>
              <button className="text-gray-500 hover:text-black px-2">
                <FaMicrophone />
              </button>
              <button className="text-green-600 hover:text-green-800 ml-2">
                <FaPaperPlane />
              </button>
            </div>
          </div>
        </div>
      </Modal>

    </>
  );
};

export default StoryBar;